import { createContext, useState } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  handleLogin: () => {},
  handleLogout: () => {},
  show: false,
  showMessageBoxHandler: () => {},  
});

export const AuthContextProvider = ({ children }) => {
  const [isLoggedIn, setLogin] = useState(false);
  const handleLogin = () => setLogin(true);
  const handleLogout = () => setLogin(false);
  const [show, setShow] = useState(false); 
  const showMessageBoxHandler = () => {
    setShow(!show);
  };
  
 
  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        handleLogin,
        handleLogout,
        show,        
        showMessageBoxHandler        
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
